<template>
  <div class="content">
    <div class="title">儿童隐私保护指引</div>
    公司名称：杭州韵玟科技有限公司
    <br />
    更新日期：2024年11月28日
    <br />
    本协议是由用户（以下简称为"您"）与杭州韵玟科技有限公司及其关联公司及第三方合作公司（以下简称为"我们"）就我们所提供的游戏产品及服务所订立的协议。有关儿童个人信息保护的联系邮箱为：youxi@yunwente.cn。除《用户注册协议》、《用户隐私协议》外，我们还将通过《儿童隐私保护指引》（本指引）
    帮助您和孩子（本指引中的“孩子”，是指不满十四周岁的未成年人）进一步了解我们收集、使用、存储和共享您孩子个人信息的情况，以及您和您的孩子所享有的相关权利。
    <br />
    【重要提示】：
    <br />
    本政策适用于不满十四周岁的未成年人的个人信息处理。有关您和已满十四周岁的用户的个人信息处理，请查看《用户注册协议》、《用户隐私协议》了解相关信息。我们会通过页面提示、网站公告等方式向您说明儿童个人信息收集等情况，并征得您的同意。请您仔细阅读、充分理解《用户注册协议》、《用户隐私协议》和本指引后，选择是否同意前述所有协议。
    <br />
    1.我们收集的儿童个人信息
    <br />
    在您的孩子使用我们提供的游戏产品及服务的过程中，我们仅会收集您同意我们收集的或您主动提供的有关您孩子的个人信息，以向您的孩子提供、优化我们的服务以及保障您孩子的账户安全。我们可能会收集的您孩子的个人信息的详情，请参见《用户隐私政策》。
    <br />
    同时，为验证您与您孩子的监护关系，我们可能还会收集您的联系方式（包括手机号码、电子邮箱）以及其他有助于我们判断监护关系的信息。
    <br />
    我们不会主动从第三方获取您孩子的个人信息。如未来为业务发展需要从第三方间接获取并处理您孩子的个人信息的，我们会严格遵守相关法律法规的规定，要求该第三方征得您的同意并确保其提供的信息的合法性。
    <br />
    2.我们如何使用儿童个人信息
    <br />
    我们严格遵守法律法规的规定以及与用户的约定，按照本指引及《用户注册协议》、《用户隐私协议》所述使用收集的信息，以向您的孩子提供更为优质的服务。
    <br />
    有关我们使用儿童个人信息的方式详情请参见《用户隐私协议》，若我们使用您孩子的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您孩子的个人信息前，再次向您告知并征得您的同意。
    <br />
    3.儿童个人信息的存储
    <br />
    3.1
    我们按照法律法规规定，将在中华人民共和国境内收集到的您孩子的个人信息存储于中华人民共和国境内，并依法对这些信息进行严格保密。如涉及跨境业务，我们需要向境外机构传输境内收集的相关个人信息的，我们也会根据国内法律、行政法规和相关监管部门的规定，为您孩子的个人信息提供保护。
    <br />
    3.2
    一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您孩子的个人信息。超出法律法规或监管规定的期限后，我们会按照法律法规的要求对您孩子的个人信息进行删除或者匿名化处理。
    <br />
    4.儿童个人信息的安全
    <br />
    4.1
    为了保障您孩子的信息安全，我们会在现有技术水平下采取合理必要的措施来保护孩子的信息，采取物理防护、安全技术、管理制度等措施来降低丢失、误用、非授权访问、披露和更改的风险，包括但不限于数据加密传输、防火墙和加密存储、物理访问控制以及信息访问授权控制。为此我们设置了安全程序保护您孩子的信息不会被未经授权的访问所窃取，所有的个人信息被加密储存并放置于经防火墙严格保护的内部系统。
    <br />
    4.2
    为了保障您孩子的信息安全，我们建立了专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务。
    <br />
    4.3
    若发生儿童个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并及时以公告、推送通知或邮件等形式告知您和孩子安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
    <br />
    5.儿童个人信息的更正
    <br />
    如您和孩子发现儿童个人信息有错误的，可以联系我们处理。
    <br />
    6.儿童个人信息的删除
    <br />
    6.1
    如您和孩子发现我们违反法律、行政法规的规定或者双方的约定处理儿童个人信息的，或是超出目的范围或者必要期限处理儿童个人信息的，可以通过联系我们对相关个人信息进行删除。
    <br />
    6.2 如您撤回同意的，可以联系我们，我们将按照国家有关法律规定进行处理。
    <br />
    6.3
    如您和孩子主动注销游戏账号并终止使用我们提供的全部游戏产品及服务，我们将会停止使用儿童的个人信息，但法律法规或监管部门另有规定的除外。如我们的产品或者服务停止运营，我们将根据相关法律法规规定进行通知，同时也将及时停止使用儿童个人信息，并将对保存的儿童个人信息进行删除或匿名化处理。
    <br />
    7.儿童个人信息的转移和委托处理
    <br />
    一般我们不会向第三方转移和委托第三方处理儿童个人信息，如确需第三方转移或委托第三方处理的，我们都会根据法律、行政法规的规定进行合规措施，包括但不限于对第三方进行安全评估。
    <br />
    8.儿童个人信息的披露
    <br />
    除非法律、行政法规规定应当披露或者根据与您的约定可以披露您孩子的个人信息的，我们不会披露孩子的个人信息。
    <br />
    9.变更
    <br />
    我们可能会适时对本指引进行修订。当本指引的条款发生变更时，我们会在版本更新时以适当的方式向您提示变更后的指引。请您仔细阅读变更后的隐私保护指引或指引内容，您的孩子继续使用我们提供的游戏产品及服务的即表示您同意我们按照更新后的隐私保护指引收集、处理或使用您孩子的个人信息。
    <br />
    10.其他
    <br />
    《用户注册协议》、《用户隐私协议》是我们提供游戏统一适用的一般性隐私条款，其中所规定的内容包括但不限于用户权利及信息安全保障措施等均适用于所有游戏用户。本指引是专门针对儿童的隐私保护指引，包含对于儿童个人信息的特殊保护。如《用户注册协议》、《用户隐私协议》与本指引存在不一致或矛盾之处，请以本指引为准。
    <br />
    11. 联系我们
    <br />
    当您有其他的投诉、建议、未成年人个人信息相关问题时，请通过邮箱：youxi@yunwente.cn与我们联系。我们将尽快审核所涉问题，并在验证您的用户身份后的十五天内予以回复。
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'protocol' })
</script>
